// Centralized asset URLs (public CDN)
export const ASSETS = {
    logo: "https://customer-assets.emergentagent.com/job_fd3711b8-77ed-4aa0-9c9a-b43025e73fb9/artifacts/nk7mpr7u_CIKO%20PLAIN-02.webp",
    feedback1: "https://customer-assets.emergentagent.com/job_fibonacci-entry-zone/artifacts/mkimmtgv_FEEDBACK%20-%2004.jpg",
    feedback2: "https://customer-assets.emergentagent.com/job_fibonacci-entry-zone/artifacts/0qlat7a0_FEEDBACK%20-%2005%20%281%29.jpg",
    feedback3: "https://customer-assets.emergentagent.com/job_fd3711b8-77ed-4aa0-9c9a-b43025e73fb9/artifacts/qbc61ekx_FEEDBACK%20-%2001.jpg",
    feedback4: "https://customer-assets.emergentagent.com/job_fd3711b8-77ed-4aa0-9c9a-b43025e73fb9/artifacts/hgjqn8i3_FEEDBACK%20-%2002.jpg",
    feedback5: "https://customer-assets.emergentagent.com/job_fd3711b8-77ed-4aa0-9c9a-b43025e73fb9/artifacts/s43sdmwv_FEEDBACK%20-%2003.jpg",
};

// CTA target — replace with real Telegram/WhatsApp URL when ready
export const CTA_URL = "https://t.me/Cikosuperscalper";
